import React from 'react';

const COMMUNITY_TITLE =
  'https://santaplaya-bucket.s3.amazonaws.com/CommunityTitle.webp';

const CommunitySection: React.FC = () => {
  return (
    <section className="flex flex-col items-center w-full text-center py-12 px-4 sm:px-8 md:px-12">
      {/* Title Image */}
      <img
        src={COMMUNITY_TITLE}
        alt="Community Title"
        className="mx-auto w-auto max-w-sm"
      />

      {/* Body Text */}
      <p className="font-prosto text-sea text-base md:text-lg xl:text-xl leading-relaxed max-w-2xl mt-8 mx-auto">
        From participating in local events to supporting charitable causes,
        Santa Playa Mariscos is dedicated to making a positive impact in Santa
        Barbara.
      </p>
    </section>
  );
};

export default CommunitySection;
